import { render, staticRenderFns } from "./RoleAddEdit.vue?vue&type=template&id=0d2b0376&scoped=true"
import script from "./RoleAddEdit.vue?vue&type=script&lang=js"
export * from "./RoleAddEdit.vue?vue&type=script&lang=js"
import style0 from "./RoleAddEdit.vue?vue&type=style&index=0&id=0d2b0376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2b0376",
  null
  
)

export default component.exports